exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-table-container[data-v-53075cf2] {\n  max-height: 600px;\n}\n.item-table-container.with-scroll[data-v-53075cf2] {\n  overflow-y: scroll;\n}\n.item-totals-container.with-scroll[data-v-53075cf2] {\n  padding-right: 15px;\n}\n.custom-badge.inventory-status[data-v-53075cf2] {\n  max-width: 100%;\n}\n.item-count-column[data-v-53075cf2] {\n  text-align: right;\n  padding-right: 50px;\n}\n.volume-column[data-v-53075cf2] {\n  width: 60px;\n}\n.width-column[data-v-53075cf2] {\n  width: 60px;\n}\n.actions-column[data-v-53075cf2] {\n  width: 100px;\n}\n", ""]);

// exports
